'use client';

import { c as _c } from "react/compiler-runtime";
import type { FAQ } from '@cc-shopping/contracts/credit-cards-page/schema/types';
import type { StructuredContent } from '@cc-shopping/contracts/cross-site/structured-content/types';
import { env } from '@cc-shopping/platform-env';
import { Details } from '@cc-shopping/ui/primitives/Details';
import { palette } from '@cc-shopping/ui/theme';
import { Box, Typography, type TypographyProps } from '@mui/material';
import type { ComponentType, ReactNode } from 'react';
export const FAQs = t0 => {
  const $ = _c(17);
  const {
    faqs,
    customTitleProps,
    onAccordionChange,
    canonicalPathname: t1,
    Renderer,
    renderedAnswers
  } = t0;
  const canonicalPathname = t1 === undefined ? "" : t1;
  let t2;
  if ($[0] !== canonicalPathname) {
    t2 = new URL(canonicalPathname, env.NEXT_PUBLIC_NW_URL).toString();
    $[0] = canonicalPathname;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const canonicalUrl = t2;
  let t3;
  if ($[2] !== customTitleProps) {
    t3 = <Typography variant="headline" {...customTitleProps} component="h2">Frequently asked questions</Typography>;
    $[2] = customTitleProps;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== Renderer || $[5] !== faqs || $[6] !== onAccordionChange || $[7] !== renderedAnswers) {
    let t5;
    if ($[9] !== Renderer || $[10] !== onAccordionChange || $[11] !== renderedAnswers) {
      t5 = (faq, index) => <Details key={faq.question} variant="simple" SummaryComponent={<Box sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between"
      }}><Typography variant="smallHeadline" component="h3">{faq.question}</Typography><span className="mask-icon mask-icon-expand-more expand-icon" style={{
          width: "20px",
          height: "20px",
          backgroundColor: palette.neutral.dark
        }} /></Box>} summaryComponentProps={{
        "aria-controls": `panel-content-${index}`,
        "data-testid": "accordion-summary",
        itemProp: "name",
        sx: {
          paddingY: "12px",
          paddingX: 2
        }
      }} detailsProps={{
        open: true,
        "data-testid": "accordion-wrapper",
        itemScope: true,
        itemProp: "mainEntity",
        itemType: "https://schema.org/Question",
        onToggle: t6 => {
          const {
            newState
          } = t6;
          onAccordionChange?.(index, newState === "open");
        },
        sx: {
          borderBottom: "1px solid",
          borderColor: "neutral.lighter",
          "&:first-of-type": {
            borderTop: "1px solid",
            borderColor: "neutral.lighter"
          },
          "&> summary:hover": {
            backgroundColor: "blues.lightest",
            outline: "2px solid",
            outlineColor: "blues.light"
          }
        }
      }}><Box itemScope={true} itemProp="acceptedAnswer" itemType="https://schema.org/Answer" data-testid="accordion-details" sx={{
          padding: 3
        }}><Box itemProp="text">{renderedAnswers ? renderedAnswers[index] : Renderer ? <Renderer doc={faq.answer} /> : null}</Box></Box></Details>;
      $[9] = Renderer;
      $[10] = onAccordionChange;
      $[11] = renderedAnswers;
      $[12] = t5;
    } else {
      t5 = $[12];
    }
    t4 = faqs.map(t5);
    $[4] = Renderer;
    $[5] = faqs;
    $[6] = onAccordionChange;
    $[7] = renderedAnswers;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[13] !== canonicalUrl || $[14] !== t3 || $[15] !== t4) {
    t5 = <Box itemScope={true} itemID={canonicalUrl} itemType="https://schema.org/FAQPage">{t3}{t4}</Box>;
    $[13] = canonicalUrl;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
};